import ProjectRoutes from './Project';
import CompetitionRoutes from './Competition';
import UserCenterRoutes from './UserCenter';
import ExamAndPracticeRoutes from './ExamAndPractice';
import PlayerRoutes from './Player';
import OpenCourseRoutes from './OpenCourse';
import { lazy } from 'react';
import DeclarationRoutes from './Declaration';
import CommunityRoutes from './Community';
import Gateway from './Gateway';
import LoginRoutes from './Login';
import EvaluationRoutes from './Evaluation';
import ChatAiRoutes from './chatAiThird';
import QuestionnaireRoutes from './Questionnaire';
import KnowRoutes from './KnowLedge';
import ListenCommentCourseRoutes from './ListenCommentCourse';
import TeachingRoutes from './UserCenter/Teaching';
import ActivityRoutes from './Activity';
import AiCourseEvaluationRoutes from './AiCourseEvaluation';
import PublicInvitationRoutes from './PublicInvitation';
import OnlineSeminar from './OnlineSeminar';
export const GatewayRoutes = Gateway;
export const UserCenterLayoutRoutes = UserCenterRoutes;
export const ProjectLayoutRoutes = ProjectRoutes;
export const TeachinLayoutRoutes = TeachingRoutes;
export const CompetitionLayoutRoutes = CompetitionRoutes;
export const ExamAndPracticeLayoutRoutes = ExamAndPracticeRoutes;
export const PlayerLayoutRoutes = PlayerRoutes;
export const OpenCourseLayoutRoutes = OpenCourseRoutes;
export const DeclarationLayoutRoutes = DeclarationRoutes;
export const CommunityLayoutRoutes = CommunityRoutes;
export const LoginLayoutRoutes = LoginRoutes;
export const EvaluationLayoutRoutes = EvaluationRoutes;
export const ChatAiLayoutRoutes = ChatAiRoutes;
export const QuestionnaireLayoutRoutes = QuestionnaireRoutes;
export const KnowLayoutRoutes = KnowRoutes;
export const ListenCommentCourseLayoutRoutes = ListenCommentCourseRoutes;
export const ActivityLayoutRoutes = ActivityRoutes;
export const AiCourseEvaluationLayoutRoutes = AiCourseEvaluationRoutes;
export const PublicInvitationLayoutRoutes = PublicInvitationRoutes;
export const TenantRoutes = [
    {
        label: '',
        key: 'TenantRoutes',
        path: '/tenant/:id',
        element: lazy(() => import('@/page/TenantSelect/qhb'))
    },
    {
        label: '',
        key: 'WcbTenantRoutes',
        path: '/wcb_tenant',
        element: lazy(() => import('@/page/TenantSelect/wcb'))
    },
    {
        label: '',
        key: '2025WcbTenantRoutes',
        path: '/2025/wcb_tenant',
        element: lazy(() => import('@/page/TenantSelect/2025Wcb'))
    },
    {
        label: '',
        key: 'InvalidLink',
        path: '/invalid-link',
        element: lazy(() => import('@/page/InvalidLink/'))
    },
    // 2025年启航杯 市级页面
    {
        label: '',
        key: '2025QhbCityRoutes',
        path: '/2025/city_qhb_tenant/:id',
        element: lazy(() => import('@/page/TenantSelect/2025Qhb'))
    },
    // 2025年启航杯 区级页面
    {
        label: '',
        key: '2025QhbRegionRoutes',
        path: '/2025/region_qhb_tenant/:id',
        element: lazy(() => import('@/page/TenantSelect/2025Qhb/region'))
    },
    {
        label: '',
        key: '2025QhbAiAnalysis',
        path: '/2025/city_qhb_tenant/ai_analysis/:id',
        element: lazy(() => import('@/page/TenantSelect/2025Qhb/AiAnalysis'))
    },
      {
        label: '',
        key: 'year-report',
        path: '/year-report',
        element: lazy(() => import('@/page/YearReport'))
    }
];

export const UsuallyRoutes = [
    {
        label: '',
        key: 'usually',
        path: '/',
        element: lazy(() => import('src/components/Layout/CommonLayout')),
        children: [
            {
                label: '无权限',
                key: 'no-auth',
                path: '/no-auth',
                element: lazy(() => import('@/page/noAuth'))
            },
            {
                label: '学习记录',
                key: 'study-log',
                path: '/study-log',
                element: lazy(() => import('@/page/Home/studyLog'))
            },
            {
                label: '无权限',
                key: 'error-map',
                path: '/error-map/:errorCode',
                element: lazy(() => import('@/page/ErrorMap'))
            }
        ]
    }
];
export const OnlineSeminarRoutes = OnlineSeminar;
